import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useProductImage } from '../../../services/productImage';
import { jhTheme } from '../../../themeProvider';

export const ContractCard = ({ data }: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { productImage, isLoading } = useProductImage(data.equipmentSerialNr);

  const handleClick = () => {
    navigate(`/detail/${data.contractNr}/${data.contractPosition}`);
  };

  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 0,
        '&:hover': {
          backgroundColor: jhTheme.palette.action.hover,
        },
      }}
      variant="outlined"
      onClick={handleClick}
    >
      <CardActionArea>
        <Stack
          direction="row"
          spacing={1}
          sx={{ paddingLeft: 2, backgroundColor: '#E5E5E5' }}
        >
          {data.contractType === 'STR' ? (
            <Typography variant="subtitle2">{t('str')}</Typography>
          ) : (
            <Typography variant="subtitle2">{t('RFM')}</Typography>
          )}
        </Stack>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={11}>
              <Stack spacing={2}>
                <Typography variant="headlineVehicleSmall">
                  {data.equipmentName}
                </Typography>
                {/* <Stack direction="row" justifyContent="space-between"> */}
                <Stack>
                  <Grid container spacing={2}>
                    {/* Vertragsnummer/Seriennummer */}
                    <Grid item xs={3}>
                      <Stack direction="row" spacing={1}>
                        <Stack direction="column">
                          <Stack direction="column">
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700 }}
                            >
                              {t('SerialNumber')}:
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700 }}
                            >
                              {t('ContractNumber')}:
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack direction="column">
                          <Stack direction="column">
                            <Typography variant="caption">
                              {data.equipmentSerialNr}
                            </Typography>
                            <Typography variant="caption">
                              {data.contractNr}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>

                    {/* Verwendung/Referenz */}
                    <Grid item xs={4}>
                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ paddingLeft: 2 }}
                      >
                        <Stack direction="column">
                          <Stack direction="column">
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700 }}
                            >
                              {t('Usage')}:
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700 }}
                            >
                              {t('Reference')}:
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack direction="column">
                          <Stack direction="column">
                            <Typography variant="caption">
                              {data.contractUsage}
                            </Typography>
                            <Typography variant="caption">
                              {data.orderNr}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>

                    {/* Begin/Ende */}
                    <Grid item xs={3}>
                      <Stack direction="row" spacing={1}>
                        <Stack direction="column">
                          <Stack direction="column">
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700 }}
                            >
                              {t('Begin')}:
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ fontWeight: 700 }}
                            >
                              {t('End')}:
                            </Typography>
                          </Stack>
                        </Stack>
                        <Stack direction="column">
                          <Stack direction="column">
                            <Typography variant="caption">
                              {data.beginDate}
                            </Typography>
                            <Typography variant="caption">
                              {data.endDate}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>

                    {/* Rate/Hours */}
                    <Grid item xs={2}>
                      <Stack direction="column">
                        <Stack direction="column">
                          <Typography
                            variant="caption"
                            sx={{ fontWeight: 900, fontSize: 12 }}
                          >
                            {data.hours}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ fontWeight: 900, fontSize: 12 }}
                          >
                            {data.rate}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
                {/* </Stack> */}
              </Stack>
            </Grid>
            <Grid item xs={1}>
              {!isLoading && productImage?.thumb ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '70px',
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 'auto', maxHeight: '80px', maxWidth: '70px' }}
                    image={productImage.thumb}
                  />
                </div>
              ) : (
                <Box sx={{ width: 70, height: 0 }} />
              )}
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
